import { Typography, Stack, IconButton, Tooltip } from '@mui/material';
import { getColor } from '../../assets/theme';
import { HelpOutline } from '@mui/icons-material';
import { CSSProperties } from 'react';

/**
 * ContainerTitle Component
 *
 * This component renders a title with an optional "Learn More" button.
 * It uses Material-UI components for styling and layout.
 *
 * @param {Object} props - The component props
 * @param {string} props.title - The title text to display
 * @param {Function} [props.func] - Optional callback function for the "Learn More" button
 * @param {CSSProperties} [props.titleStyle] - Optional custom styles for the title
 * @returns {JSX.Element} The rendered ContainerTitle component
 */
const ContainerTitle = ({
  title,
  transactionNumber,
  func,
  titleStyle,
  clipboard,
}: {
  title: string;
  transactionNumber?: string | null;
  clipboard?: JSX.Element;
  func?: (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void);
  titleStyle?: CSSProperties;
}) => {
  const { textGray, primary } = getColor();

  const isEmptyFunc = (fn?: Function) => {
    if (!fn) return true;
    const str = fn.toString().replace(/\s/g, '');
    return str === '()=>{}' || str === 'function(){}';
  };

  return (
    <Stack direction='row' alignItems='center' gap='8px' flexWrap='wrap'>
      <Typography
        sx={[
          {
            fontSize: '24px!important',
            fontWeight: 600,
            letterSpacing: '.15px',
            lineHeight: '160%',
          },
          titleStyle || {},
        ]}
        variant='h6'
      >
        {title}
        {transactionNumber && (
          <>
            :
            <span
              style={{
                marginLeft: '10px',
                color: primary,
              }}
            >
              {transactionNumber}
            </span>
          </>
        )}
      </Typography>
      {clipboard && clipboard}
      {!isEmptyFunc(func) && (
        <Tooltip title='Learn More' placement='right-end'>
          <IconButton
            sx={{
              border: 0,
              color: textGray,
              bgcolor: 'transparent',
              ':hover': {
                color: primary,
                bgcolor: 'transparent',
              },
            }}
            disableRipple
            onClick={func}
          >
            <HelpOutline />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default ContainerTitle;
